import React, { useMemo, useState} from 'react';
import {ColumnDef} from '@tanstack/react-table';
import { Container, Row, Col, Card, Form } from "react-bootstrap";
import {useIntl} from 'react-intl';
import {useSearchParams} from 'react-router-dom';
import {DateTime} from 'luxon';
import Level3Title  from '../../../../app/common/components/title/Level3Title';
import TableMetronic from '../../../../app/common/components/table/TableMetronic';
import ConsommationsDetailleesVoip from './ConsommationsDetailleesVoip';
import ConsommationsDetailleesSwitchless from './ConsommationsDetailleesSwitchless';
import ConsommationsDetailleesResume from './ConsommationsDetailleesResume';


const order = [
    { value: 'destination', labelId: 'TELEPHONIE.CONSO.ORDER.DESTINATION' },
    { value: 'compte', labelId: 'TELEPHONIE.CONSO.ORDER.COMPTE' }
];

interface ConsommationsDetailleesProps {
    serviceId?: string;
}

const ConsommationsDetaillees = ({serviceId}: ConsommationsDetailleesProps) => {
    const intl = useIntl();

    const [searchParams, setSearchParams] = useSearchParams();
    // Le mois sélectionné est porté par l'URL (?month=yyyy-MM) ; par défaut le mois en cours
    const selectedMonth = searchParams.get('month') ?? DateTime.now().toFormat('yyyy-MM');
    const setSelectedMonth = (month: string) => {
        const params = new URLSearchParams(searchParams);
        params.set('month', month);
        setSearchParams(params, {replace: true});
    };
    const [selectedOrder, setSelectedOrder] = useState<string>('destination');
    const [viewMobile4g] = useState<boolean>(false);


    const [fichesTelMobile] = useState<Array<any>>([]);
    const [facturation4GListing] = useState<Array<any>>([]);


    // Générer les mois depuis 2014 jusqu'à maintenant
    const tabMonths = useMemo(() => {
        const now = new Date();
        const months: { value: string; label: string }[] = [];
        let year = now.getFullYear();
        let month = now.getMonth() + 1;

        while (year > 2013) {
        const val = `${year}-${String(month).padStart(2, '0')}`;
        const monthLabel = intl.formatDate(new Date(year, month - 1, 1), {month: 'long', year: 'numeric'});
        const label = monthLabel.charAt(0).toUpperCase() + monthLabel.slice(1);
        months.push({ value: val, label });

        // Decrement month/year
        month--;
        if (month === 0) {
            month = 12;
            year--;
        }
        }

        return months;
    }, [intl]);


    const columnsMobile4g = useMemo<ColumnDef<any>[]>(() => {
        return [
        {
            header: intl.formatMessage({id: 'TELEPHONIE.CONSO.COL.PRESTATION'}),
            accessorKey: 'prestation',
        },
        {
            header: intl.formatMessage({id: 'TELEPHONIE.CONSO.COL.NOM'}),
            accessorKey: 'nom',
        },
        {
            header: intl.formatMessage({id: 'TELEPHONIE.CONSO.COL.DETAILS'}),
            accessorKey: 'details',
        }
        ];
    }, [intl]);


    const columnsMobile4gDepassement = useMemo<ColumnDef<any>[]>(() => {
        return [
        {
            header: intl.formatMessage({id: 'TELEPHONIE.CONSO.COL.PRESTATION'}),
            accessorKey: 'prestation',
        },
        {
            header: intl.formatMessage({id: 'TELEPHONIE.CONSO.COL.TYPE'}),
            accessorKey: 'type',
        },
        {
            header: intl.formatMessage({id: 'TELEPHONIE.CONSO.COL.DUREE_FACTUREE'}),
            accessorKey: 'duree',
        },
        {
            header: intl.formatMessage({id: 'TELEPHONIE.CONSO.COL.SMS'}),
            accessorKey: 'sms',
        },
        {
            header: intl.formatMessage({id: 'TELEPHONIE.CONSO.COL.DONNEES'}),
            accessorKey: 'donnees',
        },
        {
            header: intl.formatMessage({id: 'TELEPHONIE.CONSO.COL.DETAILS'}),
            accessorKey: 'details',
        },
        {
            header: intl.formatMessage({id: 'TELEPHONIE.CONSO.COL.EUR'}),
            accessorKey: 'eur',
        }
        ];
    }, [intl]);

  return (
    <Container fluid className="px-0 mb-5">
        <Card className="col-md-12">
            <Card.Header className="border-0 pt-6">
            <Card.Title>
                <Level3Title title={intl.formatMessage({id: 'TELEPHONIE.CONSO.TITLE'})} />
            </Card.Title>
            </Card.Header>

            <Card.Body className="pt-2">
            <Row className="align-items-center">
                <Col md={6}>
                <Form.Group>
                    <Form.Label className="fw-bold">{intl.formatMessage({id: 'TELEPHONIE.CONSO.MONTH'})}</Form.Label>
                    <Form.Select
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    >
                    <option value="">{intl.formatMessage({id: 'TELEPHONIE.CONSO.SELECT_MONTH'})}</option>
                    {tabMonths.map((monthItem) => (
                        <option key={monthItem.value} value={monthItem.value}>
                        {monthItem.label}
                        </option>
                    ))}
                    </Form.Select>
                </Form.Group>
                </Col>

                <Col md={6}>
                <Form.Group>
                    <Form.Label className="fw-bold">{intl.formatMessage({id: 'TELEPHONIE.CONSO.ORDER_BY'})}</Form.Label>
                    <Form.Select
                    defaultValue={selectedOrder}
                    onChange={(e) => {console.log(e.target.value); setSelectedOrder(e.target.value);}}
                    >
                    <option value="">{intl.formatMessage({id: 'TELEPHONIE.CONSO.SELECT'})}</option>
                    {order.map((orderItem) => (
                        <option key={orderItem.value} value={orderItem.value}>
                        {intl.formatMessage({id: orderItem.labelId})}
                        </option>
                    ))}
                    </Form.Select>
                </Form.Group>
                </Col>
            </Row>
            <div className="separator my-8" />

            <ConsommationsDetailleesResume selectedMonth={selectedMonth} selectedOrder={selectedOrder} serviceId={serviceId} />

            </Card.Body>
        </Card>

        { !viewMobile4g && (<div className="mt-5 mb-5">

            <ConsommationsDetailleesVoip selectedMonth={selectedMonth} selectedOrder={selectedOrder} serviceId={serviceId} />
            <div className="mt-5" />
            <ConsommationsDetailleesSwitchless selectedMonth={selectedMonth} selectedOrder={selectedOrder} serviceId={serviceId} />

        </div>)}

        { viewMobile4g && (<div className="mb-5"> {/* Wrapper for non mobile view4g */}

            { fichesTelMobile.length > 0 && (<Card className="col-md-12">
                <Card.Header className="border-0 pt-6">
                <Card.Title>
                    <Level3Title title={intl.formatMessage({id: 'TELEPHONIE.CONSO.MOBILE_4G.TITLE'})} />
                </Card.Title>
                </Card.Header>

                <Card.Body className="pt-2">
                <TableMetronic<any>
                    data={[]}
                    columns={columnsMobile4g}
                    isLoading={false}
                    searchBar
                    pagination
                />
                </Card.Body>
            </Card>)}

            <br />
            { facturation4GListing.length === 0 && (<div className="text-muted">
                <p className="mb-1">{intl.formatMessage({id: 'TELEPHONIE.CONSO.MOBILE_4G.NO_OVERAGE'})}</p>
            </div>)}

            { facturation4GListing.length > 0 && (<Card className="col-md-12">
                <Card.Header className="border-0 pt-6">
                <Card.Title>
                    <Level3Title title={intl.formatMessage({id: 'TELEPHONIE.CONSO.MOBILE_4G.OVERAGE_TITLE'})} />
                </Card.Title>
                </Card.Header>

                <Card.Body className="pt-2">
                <TableMetronic<any>
                    data={[]}
                    columns={columnsMobile4gDepassement}
                    isLoading={false}
                    searchBar
                    pagination
                />
                </Card.Body>
            </Card>)}
        </div>)}
    </Container>
  );

};

export default ConsommationsDetaillees;
